export default {
    state: {
        users: [],
        permissions: [],
        roles: [],
        skus: [], // simplified publications list just for limited-sku assignment
    },
    mutations: {
        setAdminUsers(state, payload) {
            state.users = payload
        },
        setAdminRoles(state, payload) {
            state.roles = payload
        },
        setAdminPermissions(state, payload) {
            state.permissions = payload
        },
        setAdminSkus(state, payload) {
            state.skus = payload
        },
    },
    actions: {
        async getAdminUsers(context) {
            const response = await this._vm.axios.get('/api/admin/user')
            context.commit('setAdminUsers', response.data)
        },
        async createAdminUser(context, payload) {
            await this._vm.axios.post('/api/admin/user', payload)
        },
        async updateAdminUser(context, payload) {
            const {
                id,
                roles,
                skus,
                password,
            } = payload

            await this._vm.axios.patch(`/api/admin/user/${id}`, { roles, skus, password })
        },

        async getAdminRoles(context) {
            const response = await this._vm.axios.get('/api/admin/role')
            context.commit('setAdminRoles', response.data)
        },
        async createAdminRole(context, payload) {
            await this._vm.axios.post('/api/admin/role', payload)
        },
        async updateAdminRole(context, payload) {
            const {
                id,
                name,
                permissions,
            } = payload

            await this._vm.axios.patch(
                `/api/admin/role/${id}`,
                {
                    name,
                    permissions,
                }
            )
        },
        async deleteAdminRole(context, payload) {
            await this._vm.axios.delete(`/api/admin/role/${payload}`)
        },

        async getAdminPermissions(context) {
            const response = await this._vm.axios.get('/api/admin/permission')
            context.commit('setAdminPermissions', response.data)
        },
        async createAdminPermission(context, payload) {
            await this._vm.axios.post('/api/admin/permission', payload)
        },
        async updateAdminPermission(context, payload) {
            const {
                id,
                name,
                roles,
            } = payload

            await this._vm.axios.patch(
                `/api/admin/permission/${id}`,
                {
                    name,
                    roles,
                }
            )
        },
        async deleteAdminPermission(context, payload) {
            await this._vm.axios.delete(`/api/admin/permission/${payload}`)
        },
        async getAdminSkus(context) {
            const response = await this._vm.axios.get('/api/admin/sku')
            context.commit('setAdminSkus', response.data)
        },
    }
}
